import type { InsuranceEntry, VerificationEntry } from './types';

export const DUMMY_INSURANCES: InsuranceEntry[] = [
  {
    id: 'ins-001',
    priority: 'primary',
    provider: 'Blue Shield',
    memberId: 'BSC9382740',
    groupId: 'GRP-4421',
    subscriberIsClient: true,
    subscriberFirstName: '',
    subscriberLastName: '',
    subscriberDob: null,
    subscriberRelationship: null,
    verificationStatus: 'verified',
  },
];

export const DUMMY_VERIFICATIONS: VerificationEntry[] = [
  {
    id: 'ver-001',
    insuranceId: 'ins-001',
    provider: 'Blue Shield',
    priority: 'primary',
    status: 'current',
    copayCents: 4500,
    coinsurancePercent: 10,
    deductibleCents: 50000,
    deductibleRemainingCents: 25000,
    verifiedAt: '2026-03-01T12:00:00Z',
  },
];
